import React from "react";
import { IoClose } from "react-icons/io5";
import "./ShareProduct.css";
import { imagePath } from "../../../constants/imagePath";

const ShareProduct = ({ isOpen, onClose, product, productId }) => {
  const getProductUrl = () => {
    return `${window.location.origin}${window.location.pathname}?product_id=${productId}`;
  };

  const handleCopyLink = async () => {
    const productUrl = getProductUrl();
    const message = `Take a look at this ${product?.name} on Codeinfoway\n${productUrl}`;
    await navigator.clipboard.writeText(message);
    onClose();

  };

  const handleWhatsAppShare = () => {
    const productUrl = getProductUrl();
    const message = `Take a look at this ${product?.name} on Codeinfoway\n${productUrl}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleFacebookShare = () => {
    const productUrl = getProductUrl();
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`;
    window.open(facebookUrl, '_blank');
  };

  const handleInstagramShare = () => {
    const productUrl = getProductUrl();
    const message = `Take a look at this ${product?.name} on Codeinfoway\n${productUrl}`;
    // Copy link to clipboard
    navigator.clipboard.writeText(message);
    // Open Instagram
    window.open('https://www.instagram.com', '_blank');
  };

  const handleGmailShare = () => {
    const productUrl = getProductUrl();
    const subject = `Take a look at this ${product?.name} on Codeinfoway`;
    const body = `I found this amazing product on Codeinfoway and thought you might like it:\n\n${product?.name}\n\n${productUrl}`;
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(gmailUrl, '_blank');
  };

  const handleMoreAppsShare = () => {
    const productUrl = getProductUrl();
    const title = product?.name;

    if (navigator.share) {
      // Use Web Share API for modern browsers
      navigator.share({
        title: title,
        text: `Take a look at this ${title} on Codeinfoway`,
        url: productUrl,
      }).catch(() => {
        // Fallback to copying link
        handleCopyLink();
      });
    } else {
      // Fallback for older browsers
      handleCopyLink();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={`share-modal-overlay ${isOpen ? 'active' : ''}`}>
      <div className="share-modal">
        <div className="share-modal-header">
          <h3>Share</h3>
          <button
            className="close-button"
            onClick={onClose}
          >
            <IoClose size={24} />
          </button>
        </div>

        <div className="share-options">
          <button
            className="share-option"
            onClick={handleCopyLink}
          >
            <img
              src={imagePath.copyLink}
              className="copy-link-image"
            />
            <span className="copy-link-text">Copy Link</span>
          </button>

          <button
            className="share-option"
            onClick={handleWhatsAppShare}
          >
            <img
              src={imagePath.whatsapp}
              className="copy-link-image"
            />
            <span className="copy-link-text">WhatsApp</span>
          </button>

          <button
            className="share-option"
            onClick={handleFacebookShare}
          >
            <img
              src={imagePath.facebook}
              className="copy-link-image"
            />
            <span className="copy-link-text">Facebook</span>
          </button>

          <button
            className="share-option"
            onClick={handleInstagramShare}
          >
            <img
              src={imagePath.instagram}
              className="copy-link-image"
            />
            <span className="copy-link-text">Instagram</span>
          </button>

          <button
            className="share-option"
            onClick={handleGmailShare}
          >
            <img
              src={imagePath.gmail}
              className="copy-link-image"
            />
            <span className="copy-link-text">Gmail</span>
          </button>

          <button
            className="share-option"
            onClick={handleMoreAppsShare}
          >
            <img
              src={imagePath.moreApp}
              className="copy-link-image"
            />
            <span className="copy-link-text">More Apps</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareProduct;
